import {
  AccountingConnectionsApi,
  AccountsApi,
  AcknowledgementsApi,
  ApiKeysApi,
  AuthorizationsApi,
  CardsApi,
  CashbackApi,
  ComplianceEntitiesApi,
  Configuration,
  CurrencyApi,
  DeductionsApi,
  EngagementsApi,
  ExternalBankAccountsApi,
  FormsApi,
  InstitutionsApi,
  InternalAccountsApi,
  InvoicesApi,
  LinkRequestsApi,
  MfaApi,
  NotificationsApi,
  OnboardingApi,
  PayablesApi,
  RequirementsApi,
  PayeeEngagementsApi,
  PayerEngagementsApi,
  InvoiceRowsApi,
  PayableRowsApi,
  PayeeRowsApi,
  PayeesApi,
  PayerRowsApi,
  PayersApi,
  PaymentCardsApi,
  PayoutsApi,
  PayPeriodsApi,
  PayrollsApi,
  PayStatementsApi,
  PersonsApi,
  ProfitAndLossApi,
  RolesApi,
  StakeholdersApi,
  TaxEstimatesApi,
  TaxWithholdingsApi,
  TransactionCategoriesApi,
  TransactionsApi,
  TagsApi,
  TransfersApi,
  VaultFilesApi,
  WorkDefinitionsApi,
  WorkItemsApi,
  WorkLoggingConfigsApi,
  WorkLogsApi,
  typedErrorMiddleware
} from "@wingspanhq/wingspan-api-sdk";
import { config } from "../config";
import { tokenStore } from "@services/tokenStore";
import { authRefreshMiddleware } from "./middlewares/authRefresh";
import { mfaChallengeMiddleware } from "./middlewares/mfaChallenge";

export const apiConfig = new Configuration({
  basePath: config.apiBaseUrl,
  accessToken: () => tokenStore.getAccessToken() ?? "",
  middleware: [
    authRefreshMiddleware,
    mfaChallengeMiddleware,
    typedErrorMiddleware
  ]
});

export const personsApi = new PersonsApi(apiConfig);
export const accountsApi = new AccountsApi(apiConfig);
export const internalAccountsApi = new InternalAccountsApi(apiConfig);
export const invoicesApi = new InvoicesApi(apiConfig);
export const payablesApi = new PayablesApi(apiConfig);
export const externalBankAccountsApi = new ExternalBankAccountsApi(apiConfig);
export const formsApi = new FormsApi(apiConfig);
export const transfersApi = new TransfersApi(apiConfig);
export const currencyApi = new CurrencyApi(apiConfig);
export const deductionsApi = new DeductionsApi(apiConfig);
export const engagementsApi = new EngagementsApi(apiConfig);
export const mfaApi = new MfaApi(apiConfig);
export const notificationsApi = new NotificationsApi(apiConfig);
export const authorizationsApi = new AuthorizationsApi(apiConfig);
export const rolesApi = new RolesApi(apiConfig);
export const stakeholdersApi = new StakeholdersApi(apiConfig);
export const apiKeysApi = new ApiKeysApi(apiConfig);
export const payeesApi = new PayeesApi(apiConfig);
export const payersApi = new PayersApi(apiConfig);
export const paymentCardsApi = new PaymentCardsApi(apiConfig);
export const payoutsApi = new PayoutsApi(apiConfig);
export const payrollsApi = new PayrollsApi(apiConfig);
export const payStatementsApi = new PayStatementsApi(apiConfig);
export const payPeriodsApi = new PayPeriodsApi(apiConfig);
export const workLogsApi = new WorkLogsApi(apiConfig);
export const workLoggingConfigsApi = new WorkLoggingConfigsApi(apiConfig);
export const workDefinitionsApi = new WorkDefinitionsApi(apiConfig);
export const workItemsApi = new WorkItemsApi(apiConfig);
export const vaultFilesApi = new VaultFilesApi(apiConfig);
export const linkRequestsApi = new LinkRequestsApi(apiConfig);
export const cardsApi = new CardsApi(apiConfig);
export const cashbackApi = new CashbackApi(apiConfig);
export const acknowledgementsApi = new AcknowledgementsApi(apiConfig);
export const transactionsApi = new TransactionsApi(apiConfig);
export const profitAndLossApi = new ProfitAndLossApi(apiConfig);
export const transactionCategoriesApi = new TransactionCategoriesApi(apiConfig);
export const taxEstimatesApi = new TaxEstimatesApi(apiConfig);
export const taxWithholdingsApi = new TaxWithholdingsApi(apiConfig);
export const accountingConnectionsApi = new AccountingConnectionsApi(apiConfig);
export const requirementsApi = new RequirementsApi(apiConfig);
export const payeeEngagementsApi = new PayeeEngagementsApi(apiConfig);
export const payerEngagementsApi = new PayerEngagementsApi(apiConfig);
export const payeeRowsApi = new PayeeRowsApi(apiConfig);
export const payerRowsApi = new PayerRowsApi(apiConfig);
export const invoiceRowsApi = new InvoiceRowsApi(apiConfig);
export const payableRowsApi = new PayableRowsApi(apiConfig);
export const tagsApi = new TagsApi(apiConfig);
export const institutionsApi = new InstitutionsApi(apiConfig);
export const complianceEntitiesApi = new ComplianceEntitiesApi(apiConfig);
export const onboardingApi = new OnboardingApi(apiConfig);
